export default __webpack_public_path__ + "static/genopets-4-a-8811f75049ba7a0c55a4e4f165379d71.webp";